import { theme } from 'antd'

interface OnlineIndicatorProps {
  size?: number
  borderWidth?: number
}

const OnlineIndicator = ({ size = 10, borderWidth = 2 }: OnlineIndicatorProps) => {
  const { token } = theme.useToken()

  return (
    <div
      style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'var(--ant-color-success)',
        border: `${borderWidth}px solid ${token.colorBgContainer}`,
      }}
    />
  )
}

export default OnlineIndicator
